(function() {
  const bar = document.querySelector('.sticky-atc-bar');
  const mainBtn = document.querySelector('[name="add"]');
  if (!bar || !mainBtn) return;

  // Ürün başlığı ve fiyatı al
  const title = document.querySelector('.product__title')?.textContent?.trim() || '';
  const price = document.querySelector('.price__regular .price-item--regular')?.textContent?.trim() || '';
  const titleEl = bar.querySelector('.sticky-atc-bar__title');
  const priceEl = bar.querySelector('.sticky-atc-bar__price');
  if (titleEl) titleEl.textContent = title;
  if (priceEl) priceEl.textContent = price;

  const observer = new IntersectionObserver(
    ([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    },
    { threshold: 0, rootMargin: '0px' }
  );
  observer.observe(mainBtn);

  // Sticky butona tıklanınca formu submit et
  bar.querySelector('.sticky-atc-bar__btn')?.addEventListener('click', () => {
    mainBtn.closest('form')?.requestSubmit();
  });
})();
